export default [
  {
    heading: "Innovative Solutions",
    description: "Providing state-of-the-art power solutions for businesses."
  },
  {
    heading: "Reliable Services",
    description: "Committed to delivering quality support and maintenance."
  },
  {
    heading: "Certified Excellence",
    description: "ISO 9001 & ISO 2015 certified company."
  },
  {
    heading: "Trusted by Clients",
    description: "Serving top banks, industries, and enterprises."
  }
]